import { CompanyWeightingType } from 'common/types/companyWeightingType';
import ThirdPartyCompanyEditor from '../../../shared/columns/editors/ThirdPartyCompanyEditor';

class ThirdPartyChartererEditor extends ThirdPartyCompanyEditor {
    render() {
        return super.render('CNR', CompanyWeightingType.Charterer);
    }
}

export default ThirdPartyChartererEditor;
